import React, { createContext, useContext, useState } from 'react';

const common = {
  en: {
    explore: 'Explore', myTickets: 'My Tickets', signIn: 'Sign In', signUp: 'Sign Up',
    logout: 'Logout', organiserDashboard: 'Organiser Dashboard', adminPanel: 'Admin Panel',
    heroTitle: 'YOUR NEXT ADVENTURE AWAITS', heroSubtitle: 'Discover events, buy tickets, and create memories',
    exploreEvents: 'Explore Events', allCategories: 'All', sports: 'Sports', festival: 'Festivals',
    fashion: 'Fashion', networking: 'Networking', nightlife: 'Nightlife', other: 'Other',
    featuredEvents: 'Featured Events', upcomingEvents: 'Upcoming Events', nearYou: 'Near You',
    buyTickets: 'Buy Tickets', from: 'From', soldOut: 'Sold Out', free: 'Free',
    checkout: 'Checkout', selectTickets: 'Select Tickets', quantity: 'Quantity', total: 'Total',
    proceedToPayment: 'Proceed to Payment', guestCheckout: 'Guest Checkout',
    fullName: 'Full Name', email: 'Email Address',
    loginTitle: 'Welcome Back', registerTitle: 'Join SAC Events', password: 'Password',
    confirmPassword: 'Confirm Password', haveAccount: 'Already have an account?',
    noAccount: "Don't have an account?", continueWithGoogle: 'Continue with Google',
    orContinueWith: 'or continue with',
    myTicketsTitle: 'My Tickets', downloadPDF: 'Download PDF', viewQR: 'View QR Code',
    eventDate: 'Event Date', venue: 'Venue', ticketType: 'Ticket Type',
    dashboard: 'Dashboard', myEvents: 'My Events', createEvent: 'Create Event', analytics: 'Analytics',
    payouts: 'Payouts', requestPayout: 'Request Payout', payoutHistory: 'Payout History',
    users: 'Users', events: 'Events', orders: 'Orders', auditLogs: 'Audit Logs',
    fxManagement: 'FX Management', banUser: 'Ban User',
    search: 'Search events...', loading: 'Loading...', save: 'Save', cancel: 'Cancel',
    delete: 'Delete', edit: 'Edit', publish: 'Publish', unpublish: 'Unpublish',
    noResults: 'No events found', currency: 'Currency', language: 'Language',
    close: 'Close', back: 'Back', next: 'Next', success: 'Success', error: 'Error',
    reviews: 'Reviews', writeReview: 'Write a Review', submitReview: 'Submit Review',
    yourReview: 'Share your experience', reply: 'Reply', noReviews: 'No reviews yet. Be the first!',
    filterByCity: 'Filter by city...', nearMeBtn: 'Near Me', viewAll: 'View All',
    amount: 'Amount', bankAccount: 'Bank Account / IBAN', paypalEmail: 'PayPal Email',
    note: 'Note', pending: 'Pending', approved: 'Approved', rejected: 'Rejected',
    approve: 'Approve', reject: 'Reject',
  },
  pl: {
    explore: 'Odkryj', myTickets: 'Moje Bilety', signIn: 'Zaloguj się', signUp: 'Rejestracja',
    logout: 'Wyloguj', organiserDashboard: 'Panel Promotora', adminPanel: 'Panel Admina',
    heroTitle: 'TWOJA NASTĘPNA PRZYGODA CZEKA', heroSubtitle: 'Odkryj wydarzenia, kup bilety i twórz wspomnienia',
    exploreEvents: 'Odkryj Wydarzenia', allCategories: 'Wszystkie', sports: 'Sport',
    festival: 'Festiwale', fashion: 'Moda', networking: 'Networking', nightlife: 'Nocne Życie', other: 'Inne',
    featuredEvents: 'Wyróżnione', upcomingEvents: 'Nadchodzące', nearYou: 'W Pobliżu',
    buyTickets: 'Kup Bilety', from: 'Od', soldOut: 'Wyprzedane', free: 'Bezpłatne',
    checkout: 'Zamówienie', selectTickets: 'Wybierz Bilety', quantity: 'Ilość', total: 'Razem',
    proceedToPayment: 'Przejdź do Płatności', guestCheckout: 'Zakup bez Konta',
    fullName: 'Imię i Nazwisko', email: 'Adres Email',
    loginTitle: 'Witaj Ponownie', registerTitle: 'Dołącz do SAC Events', password: 'Hasło',
    confirmPassword: 'Potwierdź Hasło', haveAccount: 'Masz już konto?', noAccount: 'Nie masz konta?',
    continueWithGoogle: 'Kontynuuj z Google', orContinueWith: 'lub kontynuuj z',
    myTicketsTitle: 'Moje Bilety', downloadPDF: 'Pobierz PDF', viewQR: 'Pokaż Kod QR',
    eventDate: 'Data Wydarzenia', venue: 'Miejsce', ticketType: 'Typ Biletu',
    dashboard: 'Panel', myEvents: 'Moje Wydarzenia', createEvent: 'Utwórz Wydarzenie', analytics: 'Analityka',
    payouts: 'Wypłaty', requestPayout: 'Poproś o Wypłatę', payoutHistory: 'Historia Wypłat',
    users: 'Użytkownicy', events: 'Wydarzenia', orders: 'Zamówienia',
    auditLogs: 'Logi Akcji', fxManagement: 'Zarządzanie FX', banUser: 'Zablokuj',
    search: 'Szukaj wydarzeń...', loading: 'Ładowanie...', save: 'Zapisz', cancel: 'Anuluj',
    delete: 'Usuń', edit: 'Edytuj', publish: 'Opublikuj', unpublish: 'Cofnij Publikację',
    noResults: 'Brak wyników', currency: 'Waluta', language: 'Język',
    close: 'Zamknij', back: 'Wstecz', next: 'Dalej', success: 'Sukces', error: 'Błąd',
    reviews: 'Recenzje', writeReview: 'Napisz Recenzję', submitReview: 'Wyślij Recenzję',
    yourReview: 'Podziel się doświadczeniem', reply: 'Odpowiedz', noReviews: 'Brak recenzji. Bądź pierwszy!',
    filterByCity: 'Filtruj po mieście...', nearMeBtn: 'W Pobliżu', viewAll: 'Wszystkie',
    amount: 'Kwota', bankAccount: 'Konto Bankowe / IBAN', paypalEmail: 'Email PayPal',
    note: 'Notatka', pending: 'Oczekujące', approved: 'Zatwierdzone', rejected: 'Odrzucone',
    approve: 'Zatwierdź', reject: 'Odrzuć',
  },
  fr: {
    explore: 'Explorer', myTickets: 'Mes Billets', signIn: 'Connexion', signUp: 'Inscription',
    logout: 'Déconnexion', organiserDashboard: 'Tableau Promoteur', adminPanel: "Panneau d'Admin",
    heroTitle: 'VOTRE PROCHAINE AVENTURE VOUS ATTEND', heroSubtitle: 'Découvrez des événements, achetez des billets, créez des souvenirs',
    exploreEvents: 'Explorer les Événements', allCategories: 'Tout', sports: 'Sport',
    festival: 'Festivals', fashion: 'Mode', networking: 'Networking', nightlife: 'Vie Nocturne', other: 'Autre',
    featuredEvents: 'En Vedette', upcomingEvents: 'À Venir', nearYou: 'Près de Vous',
    buyTickets: 'Acheter des Billets', from: 'À partir de', soldOut: 'Épuisé', free: 'Gratuit',
    checkout: 'Paiement', selectTickets: 'Sélectionner des Billets', quantity: 'Quantité', total: 'Total',
    proceedToPayment: 'Procéder au Paiement', guestCheckout: 'Achat en Invité',
    fullName: 'Nom Complet', email: 'Adresse Email',
    loginTitle: 'Bienvenue', registerTitle: 'Rejoindre SAC Events', password: 'Mot de passe',
    confirmPassword: 'Confirmer le Mot de passe', haveAccount: 'Vous avez déjà un compte?', noAccount: "Vous n'avez pas de compte?",
    continueWithGoogle: 'Continuer avec Google', orContinueWith: 'ou continuer avec',
    myTicketsTitle: 'Mes Billets', downloadPDF: 'Télécharger PDF', viewQR: 'Voir le Code QR',
    eventDate: "Date de l'Événement", venue: 'Lieu', ticketType: 'Type de Billet',
    dashboard: 'Tableau de Bord', myEvents: 'Mes Événements', createEvent: 'Créer un Événement', analytics: 'Analytique',
    payouts: 'Versements', requestPayout: 'Demander un Versement', payoutHistory: 'Historique des Versements',
    users: 'Utilisateurs', events: 'Événements', orders: 'Commandes',
    auditLogs: "Journaux d'Audit", fxManagement: 'Gestion FX', banUser: 'Bannir',
    search: 'Rechercher des événements...', loading: 'Chargement...', save: 'Sauvegarder', cancel: 'Annuler',
    delete: 'Supprimer', edit: 'Modifier', publish: 'Publier', unpublish: 'Dépublier',
    noResults: 'Aucun événement trouvé', currency: 'Devise', language: 'Langue',
    close: 'Fermer', back: 'Retour', next: 'Suivant', success: 'Succès', error: 'Erreur',
    reviews: 'Avis', writeReview: 'Écrire un Avis', submitReview: 'Soumettre', yourReview: 'Partagez votre expérience',
    reply: 'Répondre', noReviews: 'Aucun avis. Soyez le premier!',
    filterByCity: 'Filtrer par ville...', nearMeBtn: 'Près de Moi', viewAll: 'Tout voir',
    amount: 'Montant', bankAccount: 'Compte Bancaire / IBAN', paypalEmail: 'Email PayPal',
    note: 'Note', pending: 'En attente', approved: 'Approuvé', rejected: 'Rejeté',
    approve: 'Approuver', reject: 'Rejeter',
  },
  de: {
    explore: 'Entdecken', myTickets: 'Meine Tickets', signIn: 'Anmelden', signUp: 'Registrieren',
    logout: 'Abmelden', organiserDashboard: 'Organiser Dashboard', adminPanel: 'Admin-Panel',
    heroTitle: 'DEIN NÄCHSTES ABENTEUER WARTET', heroSubtitle: 'Events entdecken, Tickets kaufen, Erinnerungen schaffen',
    exploreEvents: 'Events Erkunden', allCategories: 'Alle', sports: 'Sport',
    festival: 'Festivals', fashion: 'Mode', networking: 'Networking', nightlife: 'Nachtleben', other: 'Sonstiges',
    featuredEvents: 'Empfohlene Events', upcomingEvents: 'Kommende Events', nearYou: 'In Meiner Nähe',
    buyTickets: 'Tickets Kaufen', from: 'Ab', soldOut: 'Ausverkauft', free: 'Kostenlos',
    checkout: 'Kasse', selectTickets: 'Tickets Auswählen', quantity: 'Anzahl', total: 'Gesamt',
    proceedToPayment: 'Zur Zahlung', guestCheckout: 'Als Gast Kaufen',
    fullName: 'Vollständiger Name', email: 'E-Mail-Adresse',
    loginTitle: 'Willkommen zurück', registerTitle: 'Bei SAC Events anmelden', password: 'Passwort',
    confirmPassword: 'Passwort bestätigen', haveAccount: 'Schon ein Konto?', noAccount: 'Noch kein Konto?',
    continueWithGoogle: 'Mit Google fortfahren', orContinueWith: 'oder fortfahren mit',
    myTicketsTitle: 'Meine Tickets', downloadPDF: 'PDF herunterladen', viewQR: 'QR-Code anzeigen',
    eventDate: 'Veranstaltungsdatum', venue: 'Veranstaltungsort', ticketType: 'Tickettyp',
    dashboard: 'Dashboard', myEvents: 'Meine Veranstaltungen', createEvent: 'Event erstellen', analytics: 'Analytik',
    payouts: 'Auszahlungen', requestPayout: 'Auszahlung beantragen', payoutHistory: 'Auszahlungsverlauf',
    users: 'Benutzer', events: 'Events', orders: 'Bestellungen',
    auditLogs: 'Prüfprotokolle', fxManagement: 'FX-Verwaltung', banUser: 'Sperren',
    search: 'Events suchen...', loading: 'Laden...', save: 'Speichern', cancel: 'Abbrechen',
    delete: 'Löschen', edit: 'Bearbeiten', publish: 'Veröffentlichen', unpublish: 'Zurückziehen',
    noResults: 'Keine Events gefunden', currency: 'Währung', language: 'Sprache',
    close: 'Schließen', back: 'Zurück', next: 'Weiter', success: 'Erfolg', error: 'Fehler',
    reviews: 'Bewertungen', writeReview: 'Bewertung schreiben', submitReview: 'Absenden',
    yourReview: 'Teile deine Erfahrung', reply: 'Antworten', noReviews: 'Noch keine Bewertungen. Sei der Erste!',
    filterByCity: 'Nach Stadt filtern...', nearMeBtn: 'In der Nähe', viewAll: 'Alle anzeigen',
    amount: 'Betrag', bankAccount: 'Bankkonto / IBAN', paypalEmail: 'PayPal-E-Mail',
    note: 'Notiz', pending: 'Ausstehend', approved: 'Genehmigt', rejected: 'Abgelehnt',
    approve: 'Genehmigen', reject: 'Ablehnen',
  },
  it: {
    explore: 'Esplora', myTickets: 'I Miei Biglietti', signIn: 'Accedi', signUp: 'Registrati',
    logout: 'Esci', organiserDashboard: 'Dashboard Promotore', adminPanel: 'Pannello Admin',
    heroTitle: 'LA TUA PROSSIMA AVVENTURA TI ASPETTA', heroSubtitle: 'Scopri eventi, acquista biglietti, crea ricordi',
    exploreEvents: 'Esplora gli Eventi', allCategories: 'Tutti', sports: 'Sport',
    festival: 'Festival', fashion: 'Moda', networking: 'Networking', nightlife: 'Vita Notturna', other: 'Altro',
    featuredEvents: 'In Evidenza', upcomingEvents: 'Prossimi', nearYou: 'Vicino a Te',
    buyTickets: 'Acquista Biglietti', from: 'Da', soldOut: 'Esaurito', free: 'Gratuito',
    checkout: 'Pagamento', selectTickets: 'Seleziona Biglietti', quantity: 'Quantità', total: 'Totale',
    proceedToPayment: 'Procedi al Pagamento', guestCheckout: 'Acquisto come Ospite',
    fullName: 'Nome Completo', email: 'Indirizzo Email',
    loginTitle: 'Bentornato', registerTitle: 'Unisciti a SAC Events', password: 'Password',
    confirmPassword: 'Conferma Password', haveAccount: 'Hai già un account?', noAccount: 'Non hai un account?',
    continueWithGoogle: 'Continua con Google', orContinueWith: 'o continua con',
    myTicketsTitle: 'I Miei Biglietti', downloadPDF: 'Scarica PDF', viewQR: 'Visualizza Codice QR',
    eventDate: "Data dell'Evento", venue: 'Luogo', ticketType: 'Tipo di Biglietto',
    dashboard: 'Dashboard', myEvents: 'I Miei Eventi', createEvent: 'Crea Evento', analytics: 'Analisi',
    payouts: 'Pagamenti', requestPayout: 'Richiedi Pagamento', payoutHistory: 'Cronologia Pagamenti',
    users: 'Utenti', events: 'Eventi', orders: 'Ordini',
    auditLogs: 'Log di Audit', fxManagement: 'Gestione FX', banUser: 'Banna',
    search: 'Cerca eventi...', loading: 'Caricamento...', save: 'Salva', cancel: 'Annulla',
    delete: 'Elimina', edit: 'Modifica', publish: 'Pubblica', unpublish: 'Ritira',
    noResults: 'Nessun evento trovato', currency: 'Valuta', language: 'Lingua',
    close: 'Chiudi', back: 'Indietro', next: 'Avanti', success: 'Successo', error: 'Errore',
    reviews: 'Recensioni', writeReview: 'Scrivi una Recensione', submitReview: 'Invia',
    yourReview: 'Condividi la tua esperienza', reply: 'Rispondi', noReviews: 'Nessuna recensione. Sii il primo!',
    filterByCity: 'Filtra per città...', nearMeBtn: 'Vicino a Me', viewAll: 'Vedi tutto',
    amount: 'Importo', bankAccount: 'Conto Bancario / IBAN', paypalEmail: 'Email PayPal',
    note: 'Nota', pending: 'In sospeso', approved: 'Approvato', rejected: 'Rifiutato',
    approve: 'Approva', reject: 'Rifiuta',
  },
};

const LanguageContext = createContext(null);

export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'pl', label: 'Polski', flag: '🇵🇱' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem('sac_lang');
    return stored && common[stored] ? stored : 'en';
  });

  const setLanguage = (l) => {
    if (!common[l]) return;
    setLang(l);
    localStorage.setItem('sac_lang', l);
  };

  const t = (key) => common[lang]?.[key] || common['en']?.[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
